export default "__VITE_ASSET__DEMX$FrB__"